import { Currency } from '@/core/currency/interfaces';

const BMD: Currency = {
    name: 'Bermudian Dollar',
    demonym: 'Bermudian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '060',
    symbol: '$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BMD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BMD;
